import {
  GET_IN_LAN_DONG_LAI,
  GET_IN_LAN_DONG_LAI_SUCCESS,
  GET_IN_LAN_DONG_LAI_FAILURE,
} from "./actionTypes";

export const getInLanDongLai = (dataSearch) => ({
  type: GET_IN_LAN_DONG_LAI,
  dataSearch,
});

export const getInLanDongLaiSuccess = (data) => ({
  type: GET_IN_LAN_DONG_LAI_SUCCESS,
  payload: data,
});

export const getInLanDongLaiFailure = () => ({
  type: GET_IN_LAN_DONG_LAI_FAILURE,
});
